/** Small colored chip for a booking's state. Colour is inferred from the
 *  display label so it stays correct regardless of the backend enum values;
 *  the label text is always `booking_state_display`. */
import { Chip } from '@mui/material';

type ChipColor = 'success' | 'default' | 'warning' | 'info' | 'error';

interface Props {
  booking_state: number;
  booking_state_display: string;
}

function colorFor(display: string): ChipColor {
  const s = display.toLowerCase();
  if (s.includes('cancel')) return 'default';
  if (s.includes('hold')) return 'info';
  if (s.includes('pend') || s.includes('await') || s.includes('provision')) return 'warning';
  if (s.includes('fail') || s.includes('error') || s.includes('reject')) return 'error';
  if (s.includes('book') || s.includes('confirm') || s.includes('complete')) return 'success';
  return 'default';
}

export function BookingStateChip({ booking_state, booking_state_display }: Props) {
  return (
    <Chip
      size="small"
      color={colorFor(booking_state_display)}
      label={booking_state_display || String(booking_state)}
    />
  );
}
